module.exports = __webpack_public_path__ + "img/create-video-btn.45c0de3f.svg";